import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Platform, PopoverController, ViewWillEnter, ViewWillLeave } from "@ionic/angular";
import { Subscription } from "rxjs";
import { MaterialsWsDao } from "../../core/dao/ws/materials.ws.dao";
import { DepartureMaterialDto } from "../../core/dto/material.dto";
import { OrderDto } from "../../core/dto/order.dto";
import { ServersConnectionsProvider } from "../../core/providers/serversConnections.provider";
import { OrderService } from "../../core/services/order.service";
import { DeviceHelper } from "../../gyzmo-commons/helpers/device.helper";
import { LoadingHelper } from "../../gyzmo-commons/helpers/loading.helper";
import { NavControllerExtended } from "../../gyzmo-commons/helpers/navControllerExtended";
import { isNullOrEmpty } from "../../gyzmo-commons/helpers/null.helper";
import { DepartureSignaturePopover } from "../popovers/departure-signature/departure-signature.popover";

@Component({
    selector: "page-departure",
    templateUrl: "departure.page.html",
    styleUrls: ["departure.page.scss"],
})
export class DeparturePage implements ViewWillEnter, ViewWillLeave {
    order: OrderDto;
    lines: DepartureMaterialDto[];
    showSignature: boolean = true;

    backRegistration: Subscription;

    constructor(private navCtrl: NavControllerExtended,
                private popoverController: PopoverController,
                private loadingHelper: LoadingHelper,
                private serversConnectionsProvider: ServersConnectionsProvider,
                private materialsWsDao: MaterialsWsDao,
                private platform: Platform,
                private deviceHelper: DeviceHelper,
                private orderService: OrderService,
                private route: ActivatedRoute) {
    }

    ionViewWillEnter() {
        let contractId = this.route.snapshot.paramMap.get("contractId");
        let invoiceId = this.route.snapshot.paramMap.get("invoiceId");
        let groupingCode = this.route.snapshot.paramMap.get("groupingCode");
        if (!isNullOrEmpty(contractId) && !isNullOrEmpty(invoiceId) && !isNullOrEmpty(groupingCode)) {
            void this.openContract(contractId, invoiceId, groupingCode);

            if (this.deviceHelper.isRunningOnDevice()) {
                this.backRegistration = this.platform.backButton.subscribeWithPriority(10000, () => {
                    if (this.order) {
                        this.order = null;
                        this.lines = null;
                    } else {
                        void this.navCtrl.pop();
                    }
                });
            }
        } else {
            //void this.navCtrl.navigateForward("/contract-search/departure");
        }
    }

    ionViewWillLeave() {
        if (this.backRegistration) {
            this.backRegistration.unsubscribe();
        }
    }

    async onValidateLine(materialDto: DepartureMaterialDto) {
        await this.loadingHelper.showLoading();

        this.materialsWsDao.save(this.serversConnectionsProvider.getPrimaryServerConnection(), materialDto)
            .then(async () => {
                this.sortLines();

                await this.loadingHelper.hideAll();
            })
            .catch(() => this.loadingHelper.hideAll());
    }

    public async openContract(contractId: string, invoiceId: string, groupingCode: string) {
        await this.loadingHelper.showLoading();
        let serverConnectionById = this.serversConnectionsProvider.getPrimaryServerConnection();

        void this.orderService.getByIdOnline(serverConnectionById, contractId)
            .then(order => {
                this.order = order;

                void this.materialsWsDao.getDepartureMaterialLines(serverConnectionById, invoiceId, groupingCode)
                    .then(async lines => {
                        this.lines = lines;

                        await this.loadingHelper.hideAll();
                    });
            });
    }

    onConstructionSiteChangeClick() {
        void this.navCtrl.navigateForward("/contract-search/departure");
    }

    public async onCustomerSignatureClick() {
        const popover = await this.popoverController.create({
            component: DepartureSignaturePopover,
            componentProps: { order: this.order },
            translucent: true,
            animated: false,
            backdropDismiss: false,
        });

        void popover.onWillDismiss()
            .then(result => {
                if (result.data) {
                    this.showSignature = false;
                }
            });

        await popover.present();
    }

    private sortLines() {
        this.lines = this.lines.sort(DepartureMaterialDto.sorter);
    }
}
